export enum ECounters {
  MESSAGE = 'message',
  VISIT = 'visit',
  PHOTO_REQUEST = 'photoRequest',
  FAVORITE = 'favorite',
}

export type ICounters = Record<ECounters, number>;

export interface IApiCounters {
  data: {
    type: 'counter';
    id: string;
    attributes: ICounters;
  };
}
